module.exports = __webpack_public_path__ + "img/a5.ddfb0f75.jpg";